module.exports = __webpack_public_path__ + "img/rakuraku.4ac7e2ec.png";